const leftMenu = {
	vds: {
		title: 'service/your_vds',
		link: '/vds/list',
		tabs: {
			'vds': 'menu/vds',
			'disks': 'service/extdisks',
			'backups': 'service/backups',
			'sshkey': 'sshkey/title',
			'iso': 'service/iso',
			'additional-services': 'service/additional'
		}
	},
	dns: {
		title: 'menu/dns',
		link: '/dns/list',
		tabs: {
			'dns': 'menu/dns'
		}
	},
	operation: {
		title: 'menu/finance',
		link: '/operation/list',
		tabs: {
			'operation': 'operation/title'
		}
	},
	partner: {
		title: 'menu/partprog',
		link: '/partner/list',
		tabs: {
			'partner': 'partner/title',
			'partneractions': 'partneractions/title'
		}
	},
	bonus: {
		title: 'bonus/title',
		link: '/bonus/convert',
		tabs: {
			'bonus': 'bonus/title'
		}
	},
	ticket: {
		title: 'menu/support',
		link: '/qa/list',
		tabs: {
			'qa': 'menu/support',
			'ticket': 'ticket/tickets'
		}
	},
	dashboard: {
		title: 'main/my_account',
		link: '/dashboard/info',
		tabs: {
			'dashboard': 'main/my_account_info',
			'options': 'options/edit_title',
			'user': 'user/title',
			'alerts': 'main/email_subs_mini',
			'request': 'request/history',
			'logs': 'logs/title'
		}
	}
}
///////////////////////////////////////////////////////////////////////////////
export default leftMenu
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/store/client-left-menu-vdsina-com.js